var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2H10C8.34315 2 7 3.34314 7 5V15C7 16.6569 8.34314 18 10 18H18C19.6569 18 21 16.6569 21 15V5C21 3.34315 19.6569 2 18 2ZM9 5C9 4.44772 9.44772 4 10 4H18C18.5523 4 19 4.44772 19 5V15C19 15.5523 18.5523 16 18 16H10C9.44771 16 9 15.5523 9 15V5Z",
    fill: "#878793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C16.5523 20 17 20.4477 17 21C17 21.5523 16.5523 22 16 22H6C4.34315 22 3 20.6569 3 19V7C3 6.44772 3.44772 6 4 6C4.55228 6 5 6.44772 5 7V19C5 19.5523 5.44772 20 6 20H16Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-copy.de5864c38020bed9776f5496d6176336.svg";